export default __webpack_public_path__ + "static/media/CVenglish.fbb1677c.pdf";